import { useState, useEffect, useRef } from "react"; // 新增 useRef 用于获取DOM元素
import { Button } from "react-bootstrap";
import { useNavigate } from "react-router-dom";

const ArticleCard = ({ article }) => {
  const { header, download_links } = article;
  const navigate = useNavigate();
  const [isExpanded, setIsExpanded] = useState(false);
  const [isOverflow, setIsOverflow] = useState(false);
  const abstractRef = useRef(null);


  const textStyle = {
    color: "#555",
    fontSize: "14px",
    lineHeight: "1.6", 
    textAlign: "justify",
    margin: 0,
    overflow: "hidden", 
    transition: "all 0.3s ease",
    display: isExpanded ? "block" : "-webkit-box",  
    WebkitLineClamp: isExpanded ? "unset" : 3,
    WebkitBoxOrient: "vertical",
    textOverflow: "ellipsis",
  };

  const toggleBtnStyle = {
    textAlign:"end",
    cursor:"pointer",
    padding: "4px 12px",
    fontSize: "13px",
    fontWeight: "500",
    color: "#003366",
    borderColor: "#007bff",
    marginTop: "4px",
    '&:hover': {
      backgroundColor: "#007bff",
      color: "#fff",
    },
  };

  useEffect(() => {
    if (abstractRef.current && header?.abstract) {
      const { scrollHeight, clientHeight } = abstractRef.current;
      setIsOverflow(scrollHeight > clientHeight);
    }
  }, [header?.abstract, isExpanded]);

  const toggleExpand = () => {
    setIsExpanded(!isExpanded);
  };

  return (
    <article
      className="card mb-20 article-card-home card-tab"
      style={{
        display: "flex",
        flexDirection: "column",
        height: "100%",
      }}
    >
      <div style={{ flex: "1" }}>
        <div
          style={{ height: "100%" }}
          className="d-flex flex-column justify-between"
        >
          {/* 文章类型和开放获取标识（不变） */}
          <div
            className="mb-15"
            style={{ display: "flex", alignItems: "center", gap: "10px" }}
          >
            {header.doi_access_wrapper && (
              <>
                <span className="article-type-badge">
                  {header.doi_access_wrapper.item_category}
                </span>
                <div className="vr" />
                {header.doi_access_wrapper.access_type && (
                  <span className="access-type-badge">
                    {header.doi_access_wrapper.access_type.access_label}
                  </span>
                )}
              </>
            )}
          </div>

          {/* 文章标题（不变） */}
          {header.title_link && (
            <h3
              style={{
                fontSize: "1.2rem",
                lineHeight: "1.4",
                marginBottom: "15px",
                fontWeight: "600",
              }}
            >
              <a
                href={header.title_link.url}
                target="_blank"
                style={{
                  color: "#2c3e50",
                  textDecoration: "none",
                  transition: "color 0.3s ease",
                }}
                onMouseOver={(e) => (e.target.style.color = "#007bff")}
                onMouseOut={(e) => (e.target.style.color = "#2c3e50")}
              >
                {header.title_link.title}
              </a>
            </h3>
          )}

          {/* 作者信息（不变） */}
          {header.authors && (
            <div className="mb-10" style={{ color: "#666", fontSize: "14px" }}>
              {header.authors.map(({ name }, index) => (
                <span key={index} style={{ fontWeight: "500" }}>
                  {name}
                  {index < header.authors.length - 1 ? ", " : ""}
                </span>
              ))}
            </div>
          )}

          {/* 发布日期（不变） */}
          {header.published_date && (
            <div className="mb-15" style={{ color: "#888", fontSize: "13px" }}>
              Published: {header.published_date}
            </div>
          )}

          {/* 可视化摘要（不变） */}
          {header.abstract && header.abstract.visual_abstract && (
            <div style={{ marginBottom: "15px", overflow: "auto" }}>
              <img
                src={header.abstract.visual_abstract.image_url.replace("..", "")}
                alt="Article visual"
                style={{
                  width: "305px",
                  height: "auto",
                  objectFit: "cover",
                  borderRadius: "8px",
                  float: "left",
                  marginRight: "20px",
                  marginBottom: "15px",
                  shapeOutside: "margin-box",
                }}
              />
              <p
                style={{
                  color: "#555",
                  fontSize: "14px",
                  lineHeight: "1.6",
                  margin: 0,
                }}
                dangerouslySetInnerHTML={{
                  __html: header.abstract.visual_abstract.text,
                }}
              ></p>
              <div style={{ clear: "both" }}></div>
            </div>
          )}

          {header.abstract && (
            <>
              <p
                ref={abstractRef}
                style={textStyle}
                dangerouslySetInnerHTML={{
                  __html: header.abstract,
                }}
              ></p>
                <div style={{
                  textAlign:"end"
                }} className="p-0 m-0">
                <span
                style={toggleBtnStyle}
                onClick={toggleExpand}
                >
                  {isExpanded ? "Hide" : "Show More"}
                </span>
                </div>
            </>
          )}

          {/* 下载链接 */}
          {download_links && (
            <div
              className="mt-2"
              style={{ display: "flex", gap: "10px", flexWrap: "wrap" }}
            >
              {download_links.map(({ type, url, add_url }, index) => {
                if (!url) return null;
                return (
                  <div key={`url-${index}`}>
                    <a
                      href={url}
                      target="_blank"
                      rel="noreferrer"
                      style={{ display: "inline-flex", alignItems: "center" }}
                    >
                      <svg
                        t="1755829841268"
                        className="icon"
                        viewBox="0 0 1024 1024"
                        version="1.1"
                        xmlns="http://www.w3.org/2000/svg"
                        p-id="927"
                        width="24"
                        height="24"
                      >
                        <path
                          d="M590.222222 79.644444L859.022222 347.943822V881.777778c0 37.700267-30.5664 68.266667-68.266666 68.266666H233.244444c-37.700267 0-68.266667-30.5664-68.266666-68.266666V147.911111c0-37.700267 30.5664-68.266667 68.266666-68.266667h356.977778z m-11.764622 28.444445H233.244444a39.822222 39.822222 0 0 0-39.799466 38.456889L193.422222 147.911111v733.866667a39.822222 39.822222 0 0 0 38.456889 39.799466L233.244444 921.6h557.511112a39.822222 39.822222 0 0 0 39.799466-38.456889L830.577778 881.777778V359.742578L578.4576 108.088889z"
                          fill="#003366"
                          p-id="928"
                        ></path>
                        <path
                          d="M854.755556 376.337067h-215.1424c-45.528178 0-82.551467-36.431644-83.5072-81.737956l-0.017067-1.792V79.644444h28.444444v213.162667c0 29.895111 23.819378 54.232178 53.515378 55.062756l1.564445 0.022755h215.1424v28.444445z"
                          fill="#003366"
                          p-id="929"
                        ></path>
                        <path
                          d="M56.888889 494.933333m28.444444 0l853.333334 0q28.444444 0 28.444444 28.444445l0 284.444444q0 28.444444-28.444444 28.444445l-853.333334 0q-28.444444 0-28.444444-28.444445l0-284.444444q0-28.444444 28.444444-28.444445Z"
                          fill="#003366"
                          p-id="930"
                        ></path>
                        <path
                          d="M318.435556 762.311111v-63.232h22.272c40.448 0 75.264-19.968 75.264-65.28 0-47.104-34.56-62.208-76.288-62.208H272.611556V762.311111h45.824z m19.968-99.328h-19.968v-55.04h18.688c22.016 0 34.304 6.656 34.304 25.856 0 18.688-10.752 29.184-33.024 29.184zM505.827556 762.311111c55.552 0 93.952-29.952 93.952-96.256 0-66.304-38.4-94.464-96.512-94.464h-54.784V762.311111h57.344z m-5.376-36.864h-6.144v-117.248h6.144c30.72 0 52.48 12.544 52.48 57.856s-21.76 59.392-52.48 59.392z m180.48 36.864v-72.704h65.024v-38.144h-65.024v-41.728h75.776v-38.144H635.107556V762.311111h45.824z"
                          fill="#FFFFFF"
                          p-id="931"
                        ></path>
                      </svg>
                      <span>Download PDF</span>
                    </a>
                  </div>
                );
              })}

              {download_links.some((item) => item.url) &&
                download_links.some((item) => item.add_url) && (
                  <div className="vr" style={{ height: "24px" }} />
                )}

              {/* DOI按钮（不变） */}
              {download_links.map(({ type, url, add_url }, index) => {
                if (!add_url) return null;
                return (
                  <div key={`doi-${index}`}>
                    <a
                      href={add_url}
                      target="_blank"
                      rel="noreferrer"
                    >
                      <span>DOI:</span>
                      {add_url.replace(/^https?:\/\/doi\.org\//, "")}
                    </a>
                  </div>
                );
              })}
            </div>
          )}
        </div>
      </div>
    </article>
  );
};

export default ArticleCard;